var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 108,
    viewBox: "0 0 90 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 107,
    rx: 2.5,
    stroke: "#728095"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 0V107.5",
    stroke: "#728095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52.5H89.5",
    stroke: "#728095"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingImg1);
export default __webpack_public_path__ + "static/media/onboarding-img1.e88f976a16afd68244ecb8de745ab2d7.svg";
export { ForwardRef as ReactComponent };